import {createElement, PropTypes} from 'rlink-react';
import {BaseRepository} from 'rlink-repos/base';
import {BinaryContent} from 'rlink-repos/content';
import {mergeStaticOptions} from 'rlink-utils/object';

import InputBase from './InputBase';

export default class FileInput extends InputBase {
  get inputType () {
    return 'file';
  }

  get multiple () {
    return this.fromPropsOrContext('multiple');
  }

  get maxFileSize () {
    return this.fromPropsOrContext('maxFileSize');
  }

  hasValue (value) {
    return !!value;
  }

  valueChanges (event, value) {
    let fileType = 'bin';
    if (value && value.name) {
      let match = value.name.match(/\.(\w+)$/);
      if (match) {
        fileType = match[1];
      }
    }
    let binPath = BinaryContent.generateNewPath(fileType);
    return [
      ['CreateBinaryContent', {
        binaryData: value,
        contentClassName: 'BinaryContent',
        contentPath: binPath,
      }],
      ['ChangeContentValue', {
        newValue: binPath,
      }],
    ];
  }

  handleChange (ev) {
    let files = ev.dataTransfer ? ev.dataTransfer.files : ev.target.files;
    let value = this.multiple ? files : files[0];
    super.onChange({
      event: ev,
      value,
    });
    this.fireCommitValue(ev, value);
  }

  addValidationProblems (ev) {
    super.addValidationProblems(ev);
    if (this.maxFileSize && this.state.blob.size > this.maxFileSize) {
      this.addProblem(ev, 'FILE_TOO_BIG');
    }
  }

  get dropLabel () {
    return 'Upload or drop file from here.';
  }

  async componentWillMount () {
    if (this.value) {
      this.setState({
        blob: await this.fetchFileBlob(this.value),
      });
    }
  }

  async componentWillReceiveProps (nextProps, nextContext) {
    super.componentWillReceiveProps(nextProps, nextContext);
    let nextValue = this.constructor.fromPropsOrContext(
      nextProps, nextContext, 'value');
    if (nextValue && nextValue !== this.value) {
      this.setState({
        blob: nextValue,
      });
    }
  }

  async fetchFileBlob (path) {
    if (this.props.repo) {
      return (await this.props.repo.fetchContentAtPath(path)).blob;
    } else {
      throw new Error('Must provide `repo` or implement non-repo blob fetching.');
    }
  }

  componentDidMount () {
    this.dropZoneRef.addEventListener('dragenter', ev => {
      ev.stopPropagation();
      ev.preventDefault();
      this.setState({dragOver: true});
    }, false);
    this.dropZoneRef.addEventListener('dragover', ev => {
      ev.stopPropagation();
      ev.preventDefault();
      this.setState({dragOver: true});
    }, false);
    this.dropZoneRef.addEventListener('dragleave', ev => {
      ev.stopPropagation();
      ev.preventDefault();
      this.setState({dragOver: false});
    }, false);
    this.dropZoneRef.addEventListener('drop', ev => {
      ev.stopPropagation();
      ev.preventDefault();
      this.setState({dragOver: false});
      this.onChange(ev);
    }, false);
  }
  renderDownloadPreview () {
    return <span>Download {this.state.blob.name || 'file'}</span>;
  }

  renderInput () {
    return (<div>
      {this.state.blob ? (
        <a href={URL.createObjectURL(this.state.blob)}>{this.renderDownloadPreview()}</a>
      ) : []}
      <br />
      <div style={{
        border: this.state.dragOver ? '4px dashed green' : '2px dashed black',
        borderRadius: '10px',
        padding: '1em',
        display: 'inline-block',
        cursor: 'pointer',
      }}
        ref={dropZone => {
          this.dropZoneRef = dropZone;
        }}
        onClick={() => {
          this.inputRef.click();
        }}>
        {this.dropLabel}
      </div>
      <input type={this.inputType}
        ref={input => {
          this.inputRef = input;
        }}
        style={{display: 'none'}}
        required={this.required}
        disabled={this.disabled}
        name={this.fieldName}
        id={`input${this.labelId}`}
        onChange={ev => this.handleChange(ev)} />
    </div>);
  }
}


mergeStaticOptions(FileInput, {
  propTypes: {
    value: PropTypes.instanceOf(typeof Blob !== 'undefined' ? Blob : Object),
    committedValue: PropTypes.instanceOf(typeof Blob !== 'undefined' ? Blob : Object),
    maxFileSize: PropTypes.number,
    multiple: PropTypes.bool,
    repo: PropTypes.instanceOf(BaseRepository).isRequired,
  },
});



// WEBPACK FOOTER //
// ./lib/rlink-forms/inputs/FileInput.jsx